export default (opts = {}) => ({
    swiper: null,
    loop: opts.loop ?? false,

    init() {
        this.$nextTick(() => this.initSwiper());
    },

    initSwiper() {
        const swiperEl = this.$refs.complementarySwiper;
        const prevBtn = this.$refs.complementaryPrev;
        const nextBtn = this.$refs.complementaryNext;
        if (!swiperEl || !window.Swiper) return;

        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 2.5,
            spaceBetween: 8,
            pagination: false,
            loop: this.loop,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            breakpoints: {
                320: {slidesPerView: 1.5},
                480: {slidesPerView: 2},
                640: {slidesPerView: 3.5},
                1024: {slidesPerView: 3.5},
            },
            keyboard: {enabled: true},
        });
    },
});
